// CalendarManagement.tsx
// Admin Calendar Management Component - Simple wrapper for AdminCalendarDashboard

import React, { useState } from 'react';
import { Box } from '@mui/material';
import AdminCalendarDashboard from './calendar/AdminCalendarDashboard';
import BulkSlotCreator from './calendar/BulkSlotCreator';
import './CalendarManagement.css';

const CalendarManagement: React.FC = () => {
  const [showBulkCreate, setShowBulkCreate] = useState(false);
  const [refreshDashboard, setRefreshDashboard] = useState(0);

  const handleBulkCreateSuccess = () => {
    setShowBulkCreate(false);
    // Trigger dashboard refresh by changing key
    setRefreshDashboard(prev => prev + 1);
  };

  return (
    <Box sx={{ width: '100%' }}>
      {/* AdminCalendarDashboard handles all tabs, header, and button internally */}
      <AdminCalendarDashboard
        key={refreshDashboard}
        onCreateSlot={() => setShowBulkCreate(true)}
      />

      {/* Bulk Slot Creator Dialog */}
      <BulkSlotCreator
        open={showBulkCreate}
        onClose={() => setShowBulkCreate(false)}
        onSuccess={handleBulkCreateSuccess}
      />
    </Box>
  );
};

export default CalendarManagement;